import { render, staticRenderFns } from "./ObservationRespondingForm.vue?vue&type=template&id=71ae0f0a&scoped=true"
import script from "./ObservationRespondingForm.vue?vue&type=script&lang=js"
export * from "./ObservationRespondingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae0f0a",
  null
  
)

export default component.exports